import * as React from 'react';
import { Header4, Image } from '@cian/ui-kit';

import * as styles from './BuilderField.css';

interface IBuilderFieldProps {
  imageUrl: string;
  url: string;
  name: string;
  stats: React.ReactElement;
}

export const BuilderField = (props: IBuilderFieldProps) => {
  const { imageUrl, name, stats, url } = props;

  return (
    <div className={styles['builder']}>
      <a target="_blank" href={url} rel="noreferrer" title={`Застройщик ${name}`} className={styles['image']}>
        <Image alt={name} objectFit="contain" width={64} height={64} borderRadius="4px" src={imageUrl} />
      </a>
      <a target="_blank" href={url} rel="noreferrer" title={`Застройщик ${name}`} className={styles['title']}>
        <Header4>{name}</Header4>
      </a>
      {stats}
    </div>
  );
};
